// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__1JGzV","small":"button_small__I8YtZ","medium":"button_medium__3AaB-","large":"button_large__v7oNO","disabled":"button_disabled__1Fhq-"};